import { render } from "./AboutFormModal.vue?vue&type=template&id=3166a8c7"
import script from "./AboutFormModal.vue?vue&type=script&lang=js"
export * from "./AboutFormModal.vue?vue&type=script&lang=js"

import exportComponent from "/builds/phi-indonesia/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__